import KindergartenSubscriptionStatus from './status';
import MomentDate from '../date';
import React from 'react';

const styles = {}

const KindergartenSubscriptionListing = ({ subscriptions=[] }) => {

  if (subscriptions.length === 0) {
    return (
      <div>Es wurden noch keine Kiga-Abos abgeschlossen.</div>
    )
  }

  const items = subscriptions.map(subscription => {
    const customer = subscription.customer
    const kindergarten = subscription.kindergarten
    const productVariant = subscription.productVariant
    const size = productVariant?.metafields?.find(field => field.key === 'Name')?.value

    return <div key={subscription.token} className={styles.item}>
      <div className={styles.token}>
        {subscription.token}<br/>
        <KindergartenSubscriptionStatus status={subscription.status}/>
      </div>
      <div className={styles.customer}>
        {customer ? <>{customer.firstname} - {customer.lastname}<br/><small>{customer.email}</small></> : 'Gelöschter Kunde'}
      </div>
      <div className={styles.child}>
        {subscription.childName}<br/>
        <small>{subscription.groupName}</small>
      </div>
      <div className={styles.kindergarten}>
         {kindergarten ? <>{kindergarten.name}<br/><small>{kindergarten.city}</small></> : 'Gelöschter Kindergarten'}
      </div>
      <div className={styles.size}>
        {size ?? (productVariant ? 'Nicht definiert' : 'Gelöschtes Produkt')}
      </div>
      <div className={styles.created}>
        <small><MomentDate date={subscription.createdAt}/></small>
      </div>
    </div>
  })

  return (
    <div className={styles.items}>
      <div className={styles.item}>
        <div className={styles.token}>Token</div>
        <div className={styles.customer}>Kunde</div>
        <div className={styles.child}>Kind</div>
        <div className={styles.kindergarten}>Kindergarten</div>
        <div className={styles.size}>Größe</div>
        <div className={styles.created}>Abgeschlossen</div>
      </div>
      {items}
    </div>
  )
}

export default KindergartenSubscriptionListing;
